import { useConfig } from '@/composables/config'
import { useAppStore } from '@/store/app-store'

export function useGoToApp() {
    const { VUE_APP_ANDROID_APP_URL, VUE_APP_IOS_APP_ADJUST_URL } = useConfig()
    const appStore = useAppStore()

    function goToApp() {
        if (appStore.platform === 'android') {
            const fallback = encodeURIComponent(VUE_APP_ANDROID_APP_URL)
            window.location.href = `intent://playgama.com${window.location.pathname}#Intent;scheme=https;package=com.playgama.twa;S.browser_fallback_url=${fallback};end`
        } else {
            const url = VUE_APP_IOS_APP_ADJUST_URL.replace('%PATH%', window.location.pathname)
            window.open(url, '_blank')
        }
    }

    return { goToApp }
}
